module.exports = __webpack_public_path__ + "img/step3.b3e3ec1c.png";